import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      sizeSelected: ""
    };
  },
  methods: {
    onSelect() {
      const { activeUGCIndex } = this.$store.state.ugc.tempData;
      if (activeUGCIndex === 1) {
        this.$ugcDataLayer.logAnalyticsEvent({
          action: 'imageLibrary',
          type: this.$ugcDataLayer.types.selectSize,
          eventLabel: this.$store.state.utils.pdm.sku,
          size: this.sizeSelected
        });
      }


      if (this.$store.state.utils.configuration.modals?.ugcSizeSelection && this.$refs.sizeSelectionModal) {
        this.$refs.sizeSelectionModal.blockCtaPrimaryButton(!this.sizeSelected);
      } else if (this.$refs.newSizeSelectionModal) {
        this.$refs.newSizeSelectionModal.blockCtaPrimaryButton(!this.sizeSelected);
      }
      this.$store.commit("ugc/tempData/SET_UGC_SIZE", this.sizeSelected);
      this.$emit('blockCtaPrimaryButton', !this.sizeSelected);
    },
    /**
     * @function onContinue
     * Save selected size in store and shows the ugc modal.
     */
     onContinue() {
      if (!this.sizeSelected) return;
      this.$store.commit("ugc/tempData/SET_UGC_SIZE", this.sizeSelected);
      this.$store.commit("buyPanel/REPLACE_SIZE_SELECTED", this.sizeSelected);
      this.load3DAssets();
    },
    /**
     * @function loadSizeAssets
     * Save selected size in store and load 3D assets.
     */
    loadSizeAssets(size) {
      this.sizeSelected = size;
      this.onContinue();
    },
    /**
     * @function load3DAssets
     * Loads 3D assets to use during ugc, like the template guide.
     */
    load3DAssets() {
      this.$store.dispatch("ugc/SAVE_ASSETS_3D").then(() => {
        this.$store.commit("ugc/SET_UGC_VIEWS");
        this.$modal.hide(this.$store.state.utils.configuration.modals?.ugcSizeSelection ? "sizeSelectionModal" : "newSizeSelectionModal");
        this.$modal.show(this.$store.state.utils.configuration.enableNewUgcModal ? "newUgcModal" : "ugcModal");
        this.setBucketSize();
      });
    },
    resetSelectField() {
      this.sizeSelected = "";
    },
    setPreselectedSize(size) {
      this.sizeSelected = size;
      this.onSelect();
    },
    setBucketSize() {
      const { tempData } = this.$store.state.ugc;
      const ugcSize = tempData.features[tempData.activeUGCIndex].ugc_size;
      if (ugcSize) {
        this.$store.commit("ugc/tempData/SET_TEMP_BUCKET_SIZE", this.$store.state.utils.bucketSizes[ugcSize]);
      }
    }
  },
  created() {
    this.$eventBus.$on("set-preselected-size", this.setPreselectedSize);
    this.$eventBus.$on("load-size-assets", this.loadSizeAssets);
  },
  mounted() {
    this.$refs.sizeSelectionModal && this.$refs.sizeSelectionModal.blockCtaPrimaryButton(!this.sizeSelected);
    this.$emit('blockCtaPrimaryButton', !this.sizeSelected);
  },
  beforeDestroy() {
    this.$eventBus.$off("set-preselected-size", this.setPreselectedSize);
    this.$eventBus.$off("load-size-assets", this.loadSizeAssets);
  }
});
